<template>
  <div class="workflow-view" data-cy="workflow-view">
    <div class="workflow-tabs">
      <UITabContainer
        v-if="tabs.length"
        class="workflow-tab-container"
        :tabs="tabs"
        :defaultTabId="workflowMode"
        @tabChanged="onTabChanged"
      >
        <template v-slot:myWork>
          <WorkflowTable :mode="EnumWorkflowMode.My" />
        </template>
        <template v-slot:allWork>
          <WorkflowTable :mode="EnumWorkflowMode.All" />
        </template>
      </UITabContainer>
    </div>
  </div>
</template>

<script setup lang="ts">
import UITabContainer from "@/shared/ui/tabs/tab-container.vue";
import WorkflowTable from "./WorkflowTable.vue";
import { EnumWorkflowMode } from "@/Domain/EnumWorkflowMode";

const urlParams = new URLSearchParams(window.location.search);
const workflowMode = urlParams.get("mode") == "my" ? "myWork" : "allWork";

const tabs = [
  {
    id: "myWork",
    label: "My Work",
  },
  {
    id: "allWork",
    label: "All Work",
  },
];

const onTabChanged = async function (tabId: string) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set("mode", tabId == "myWork" ? "my" : "all");
  window.history.pushState({}, "", `${window.location.pathname}?${urlParams}`);
};
</script>
